import { createContext, PropsWithChildren, useContext } from 'react';

import {
    ApplicationContextI,
    useInitializeApplication,
} from './ApplicationProvider.helpers';

/* --------------------------------- Context -------------------------------- */

export const ApplicationContext = createContext<ApplicationContextI | null>(
    null,
);

/* ---------------------------------- Hook ---------------------------------- */

export const useApplicationContext = () => {
    const context = useContext(ApplicationContext);

    if (!context) {
        throw new Error(
            'Cannot use ApplicationContext outside of ApplicationProvider',
        );
    }

    return context;
};

/* -------------------------------- Provider -------------------------------- */

const ApplicationProvider = ({ children }: PropsWithChildren) => {
    const { loading, data } = useInitializeApplication();

    if (loading || !data) return null;

    return (
        <ApplicationContext.Provider value={data}>
            {children}
        </ApplicationContext.Provider>
    );
};

/* --------------------------------- Export --------------------------------- */

export default ApplicationProvider;
